import $ from "jquery";
import ko from "knockout";
import protect from "flow/protect";
import register from "flow/knockout/register";

register.registerKnockoutBinding("onCreated", {
    init: function (element, valueAccessor, _allBindingsAccessor, viewModel) {
        const myFlow = viewModel.myFlow;

        protect(myFlow, this, function () {
            const callback = ko.utils.unwrapObservable(valueAccessor());
            callback($(element));
        })();
    }
});
